// @ts-nocheck
"use client";

import { useEffect, useState } from "react";
import CTABtn from "../atoms/cta-btn";
import styles from "./footer.module.css";
import Socials from "../atoms/social";
import { GoDotFill } from "react-icons/go";
import clsx from "clsx";
import { IoClose } from "react-icons/io5";
import Link from "next/link";

export default function Footer({ footerLink, button, socials }) {
    const [hoveredMenu, setHoveredMenu] = useState(null);
    const [linkList, setLinkList] = useState([]);
    const buttonAttrs = button?.attributes ?? button;

    useEffect(() => {
        const groupedLinks = footerLink?.reduce((acc, link) => {
            // Use title and link as fallback if menuTitle is missing
            const menuTitle = link.menuTitle ?? link.title;
            const menuLink = link.link ?? "#";

            // Check if the menuTitle already exists in acc
            const existingMenu = acc.find((x) => x.menuTitle === menuTitle);

            if (existingMenu) {
                // Add to titles if a menuTitle exists
                existingMenu.titles.push({
                    title: link.title,
                    link: link.link,
                });
            } else {
                // Create a new menu object if no menuTitle found
                acc.push({
                    menuTitle: menuTitle,
                    menuLink: menuLink,
                    titles: [
                        {
                            title: link.title,
                            link: link.link,
                        },
                    ],
                });
            }
            return acc;
        }, []);

        setLinkList(groupedLinks || []);
    }, [footerLink]);

    return (

        <>
            {
                (footerLink || button || socials) &&
                <div className={styles["footer-wrapper"]}>
                    <div className={styles["link-wrapper"]}>
                        {linkList &&
                            linkList.map((link, i) =>
                                (link?.titles?.length ?? 0) > 1 ? (
                                    <details
                                        key={link.menuLink}
                                        open={hoveredMenu === link.menuTitle}
                                        onMouseEnter={() => setHoveredMenu(link.menuTitle)}
                                        onClick={() =>
                                            setHoveredMenu(hoveredMenu === link.menuTitle ? null : link.menuTitle)
                                        }
                                    >
                                        <summary
                                            className={styles["main-tabs"]}
                                            style={{ pointerEvents: "none" }}
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <div
                                                className={clsx({
                                                    [styles["active-tab"]]: hoveredMenu === link.menuTitle,
                                                })}
                                            >
                                                {link.menuTitle}
                                                <GoDotFill color={"white"} size={15} />
                                            </div>
                                        </summary>
                                        <div className={clsx(styles["active-links-wrapper"], { [styles.open]: hoveredMenu === link.menuTitle })}>
                                            {/* <div className={styles["active-header"]}>
                                        
                                    </div> */}
                                            <div className={styles["active-links"]}>
                                                <div
                                                    className={styles["close-btn"]}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        setHoveredMenu(null);
                                                    }}
                                                >
                                                    <IoClose size={25} color="white" />
                                                </div>
                                                {link.titles.map((title, index) => (
                                                    title.title === link.menuTitle &&
                                                    (<div key={index} className={styles["active-link"]}>
                                                        <Link href={`${title.link}`} legacyBehavior>
                                                            <a rel="noopener noreferrer">
                                                                {link.menuTitle}
                                                            </a>
                                                        </Link>
                                                        <GoDotFill color={"white"} size={15} />
                                                    </div>)
                                                ))}
                                                {link.titles.map((title, index) => (
                                                    title.title !== link.menuTitle &&
                                                    (<div key={index} className={styles["active-link"]}>
                                                        <Link href={`${title.link}`} legacyBehavior>
                                                            <a rel="noopener noreferrer">
                                                                {title.title}
                                                            </a>
                                                        </Link>
                                                        <GoDotFill color={"white"} size={15} />
                                                    </div>)
                                                ))}

                                            </div>
                                        </div>
                                    </details>
                                ) : (
                                    <Link key={link.menuLink}
                                        href={link.menuTitle === "Careers" ? "https://jobs.vxi.com/" : link.menuLink}


                                        legacyBehavior>
                                        <a
                                            onMouseEnter={() => setHoveredMenu(link.menuTitle)}
                                            onClick={() =>
                                                setHoveredMenu(hoveredMenu === link.menuTitle ? null : link.menuTitle)}
                                            className={clsx(styles["main-tabs"], { [styles["active-tab"]]: hoveredMenu === link.menuTitle })}
                                            target={link.menuTitle === "Careers" ? "_blank" : undefined}
                                        >
                                            <div>
                                                {link.menuTitle}
                                                <GoDotFill color={"white"} size={15} />
                                            </div>
                                        </a>
                                    </Link>
                                )
                            )}
                    </div>

                    <div className={styles['socials-wrapper']}>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="1.34947 0.177365 42.99 43.01" role="img" aria-label="VXI Global Solutions">
                                <path d="M 5.348 20.105 c 0.6428 -0.8603 1.4908 -1.3903 2.3389 -1.9202 a 1 1 -32 0 1 14.4168 -9.0086 l 5.2992 8.4805 l 2.5441 -1.5898 l -5.2992 -8.4805 a 1 1 -32 0 0 -19.5051 12.1881 z m 4.0349 -2.98 l 2.5441 -1.5898 a 1 1 -32 0 1 5.9363 -3.7094 l 2.6496 4.2402 l 2.5441 -1.5898 l -2.6496 -4.2402 a 1 1 -32 0 0 -11.0246 6.889 m 4.2402 -2.6496 l 2.5442 -1.5897 a 1 1 -32 0 0 -2.5442 1.5897 m 18.0199 0.5317 l 0 0 a 1 1 -32 0 0 -1.5898 -2.5441 z m -2.6496 -4.2402 l 0 0 a 1 1 -32 0 1 3.7094 5.9363 l -12.7207 7.9488 l 1.5898 2.5441 l 12.7207 -7.9488 a 1 1 -32 0 0 -6.889 -11.0246 z m -4.5995 -6.5511 c 0.89 0.6148 1.4199 1.4628 1.9499 2.3109 l 0 0 a 1 1 -32 0 1 9.0086 14.4168 l -8.4805 5.2992 l 1.5898 2.5441 l 8.4805 -5.2992 a 1 1 -32 0 0 -12.1881 -19.5051 z m 5.1276 26.2671 a 1 1 -32 0 0 2.5441 -1.5898 l -1.6961 1.0598 z m 4.2402 -2.6496 l 0 0 a 1 1 -32 0 1 -5.9363 3.7094 l -2.6496 -4.2402 l -2.5441 1.5898 l 2.6496 4.2402 a 1 1 -32 0 0 11.0246 -6.889 z m 6.6035 -4.5308 c -0.6671 0.8213 -1.5152 1.3512 -2.3632 1.8812 l 0 0 a 1 1 -32 0 1 -14.4168 9.0086 l -5.2992 -8.4805 l -2.5441 1.5898 l 5.2992 8.4805 a 1 1 -32 0 0 19.5051 -12.1881 z m -25.2596 6.755 l -1.0598 -1.6961 a 1 1 -32 0 0 1.5898 2.5441 z m 3.1795 5.0883 l -1.5898 -2.5441 a 1 1 -32 0 1 -3.7094 -5.9363 l 12.7207 -7.9488 l -1.5898 -2.5441 l -12.7207 7.9488 a 1 1 -32 0 0 6.889 11.0246 z m 3.0715 3.9813 c -0.9518 -0.5891 -1.4817 -1.4372 -2.0117 -2.2852 l 0 0 a 1 1 -32 0 1 -9.0086 -14.4168 l 8.4805 -5.2992 l -1.5898 -2.5441 l -8.4805 5.2992 a 1 1 -32 0 0 12.1881 19.5051 z m -17.9101 -18.2927 m 19.3328 19.7184 c -6.7596 4.8489 -16.3082 2.7888 -20.2264 -5.2705 c -2.4435 -5.7522 -0.7541 -10.7121 1.4182 -13.6555 c -2.4858 -3.4818 -3.7436 -8.7462 -1.1048 -14.1001 c 3.4204 -6.6488 12.4594 -10.0672 20.0431 -4.7111 c 3.8981 -2.9971 13.0286 -4.9255 19.1289 3.335 c 4.3255 6.7977 1.5839 13.125 -0.3251 15.5973 c 4.7518 6.7873 2.7437 15.485 -4.2333 19.6785 c -4.0285 2.3298 -9.894 2.639 -14.6584 -0.8398 z" />
                            </svg>
                        </div>
                        <div className={styles['cta-links']}>
                            <div>
                                {buttonAttrs && <CTABtn btnName={buttonAttrs.buttonName} btnURL={buttonAttrs.buttonURL} newTab={buttonAttrs.newTab} colorMode='dark-mode' />}
                            </div>
                            <div>
                                {socials && (socials.data.map((social, i) => {
                                    return <Socials attr={social.attributes} key={i} />
                                }))}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}
